import SoleProprietorship from "./SoleProprietorship";

export default SoleProprietorship;
